import { render, staticRenderFns } from "./BoardAdditionalSetting.vue?vue&type=template&id=d4b5c598&scoped=true&"
import script from "./BoardAdditionalSetting.vue?vue&type=script&lang=ts&"
export * from "./BoardAdditionalSetting.vue?vue&type=script&lang=ts&"
import style0 from "./BoardAdditionalSetting.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BoardAdditionalSetting.vue?vue&type=style&index=1&id=d4b5c598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b5c598",
  null
  
)

export default component.exports